import React from "react";
import { AlertTriangle, RotateCcw, X } from "lucide-react";

const RestrictionActionModal = ({
  t,
  type,
  selectedRestriction,
  getRestrictionTypeLabel,
  reason,
  error,
  loading,
  onReasonChange,
  onClose,
  onSubmit,
}) => {
  const isRestore = type === "restore";
  const title = isRestore
    ? t("applyStrike.restriction.history.restoreModalTitle")
    : t("applyStrike.restriction.history.closeModalTitle");
  const description = isRestore
    ? t("applyStrike.restriction.history.restoreConfirm")
    : t("applyStrike.restriction.history.closeConfirm");
  const submitText = isRestore
    ? t("applyStrike.restriction.history.restoreRestriction")
    : t("applyStrike.restriction.history.closeRestriction");
  const loadingText = isRestore
    ? t("applyStrike.restriction.history.restoringRestriction")
    : t("applyStrike.restriction.history.closingRestriction");
  const Icon = isRestore ? RotateCcw : AlertTriangle;

  return (
    <div className="strike-modal-backdrop" role="presentation">
      <form className="strike-resolution-modal" onSubmit={onSubmit}>
        <div className="strike-resolution-header">
          <div>
            <h3>{title}</h3>
            <p>{selectedRestriction ? getRestrictionTypeLabel(selectedRestriction.restriction_type) : "-"}</p>
          </div>
          <button type="button" className="strike-close-btn" onClick={onClose} disabled={loading} aria-label={isRestore ? t("applyStrike.restriction.history.restoreModal") : t("applyStrike.restriction.history.closeModal")}>
            <X size={18} />
          </button>
        </div>

        <div className={`restriction-confirm-copy ${isRestore ? "restriction-restore-copy" : ""}`}>
          <Icon size={20} />
          {isRestore ? (
            <span>{description}</span>
          ) : (
            <div>
              <strong>{t("applyStrike.restriction.history.closeConfirmWarning")}</strong>
              <span>{description}</span>
            </div>
          )}
        </div>

        <div className="strike-field">
          <label className="strike-field-label" htmlFor={`restriction-${type}-reason`}>
            {t("applyStrike.reason")} <span className="strike-required">*</span>
          </label>
          <input
            id={`restriction-${type}-reason`}
            className="strike-input"
            value={reason}
            onChange={(event) => onReasonChange(event.target.value)}
            placeholder={t("applyStrike.restriction.placeholders.reason")}
          />
          {error ? <span className="strike-error">{error}</span> : null}
        </div>

        <div className="strike-resolution-actions">
          <button type="button" className="strike-btn-cancel" onClick={onClose} disabled={loading}>
            {t("applyStrike.cancel")}
          </button>
          <button type="submit" className={`strike-btn-submit ${isRestore ? "" : "restriction-destructive-btn"}`} disabled={loading}>
            {loading ? <><i className="fas fa-spinner fa-spin" /> {loadingText}</> : submitText}
          </button>
        </div>
      </form>
    </div>
  );
};

export default RestrictionActionModal;
